// extracted by extract-css-chunks-webpack-plugin
module.exports = {"app":"app-global--app","skipToContent":"app-global--skipToContent"};